import apiClient from '@/api/client';

export const DEMO_HOSPITALS = [
  {
    id: '1001',
    name: 'Apollo Memorial Multi-Specialty Hospital',
    code: 'AMH',
    city: 'Bengaluru',
    state: 'Karnataka',
    status: 'ACTIVE',
    clinicsCount: 4,
  },
  {
    id: '1002',
    name: 'Fortis Health City Medical Institute',
    code: 'FHM',
    city: 'Mumbai',
    state: 'Maharashtra',
    status: 'ACTIVE',
    clinicsCount: 3,
  },
  {
    id: '1003',
    name: 'Max Super Care Hospital',
    code: 'MAX',
    city: 'New Delhi',
    state: 'Delhi',
    status: 'ACTIVE',
    clinicsCount: 5,
  },
];

export const hospitalService = {
  /**
   * Verify hospital existence before login
   * GET /api/v1/hospitals/{hospitalId}/verify or GET /api/v1/hospitals/{hospitalId}/public
   */
  verifyHospital: async (hospitalId) => {
    const cleanId = String(hospitalId).trim();
    if (!cleanId) {
      throw new Error('Please enter a valid Hospital ID');
    }

    try {
      const response = await apiClient.get(`/hospitals/${cleanId}/public`);
      const body = response.data?.data || response.data;
      if (body && (body.exists || body.id)) {
        return body.hospital || body;
      }
      throw new Error(`Hospital ID "${cleanId}" does not exist.`);
    } catch (err) {
      // Check fallback mock demo hospitals if backend returned 404 or in development
      const demo = DEMO_HOSPITALS.find((h) => h.id === cleanId);
      if (demo) {
        return demo;
      }
      const errorMsg =
        err.response?.data?.message ||
        err.response?.data?.error ||
        `Hospital ID "${cleanId}" does not exist. Please check your ID or contact your administrator.`;
      throw new Error(errorMsg);
    }
  },

  /**
   * Get all active clinics for a hospital
   * GET /api/v1/hospitals/{hospitalId}/clinics
   */
  getHospitalClinics: async (hospitalId) => {
    try {
      const response = await apiClient.get(`/hospitals/${hospitalId}/clinics`);
      return response.data?.data || response.data || [];
    } catch (err) {
      return [
        {
          id: '101',
          name: 'General Medicine OPD',
          code: 'GEN',
          department: 'Internal Medicine',
          floor: 'Ground Floor, Wing A',
          operatingHours: '08:00 AM - 04:00 PM',
          status: 'ACTIVE',
        },
        {
          id: '102',
          name: 'Cardiology Speciality Clinic',
          code: 'CARD',
          department: 'Cardiology',
          floor: '1st Floor, Block B',
          operatingHours: '09:00 AM - 05:00 PM',
          status: 'ACTIVE',
        },
        {
          id: '103',
          name: 'Pediatrics & Child Care OPD',
          code: 'PED',
          department: 'Pediatrics',
          floor: 'Ground Floor, Wing C',
          operatingHours: '09:00 AM - 05:00 PM',
          status: 'ACTIVE',
        },
      ];
    }
  },
};

export default hospitalService;

